import React, { forwardRef, useCallback, useImperativeHandle, useMemo, useState, useEffect, useRef } from 'react'
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Button, Card, HTMLTable, Icon, Popover, ResizeSensor } from '@blueprintjs/core'
import { globalOnDemandVars } from '../../../../../helper/context'
import LoadingCoverSimple from '../../../../commonInterface/loadingCoverSimple'
import { InsertFormClass } from '../classes'
import { hasScrollbarAlways } from '../../../../../helper/CSSclasses'
import { OverlayProps } from '../../../../../helper/configs'
import { produce } from 'immer'
import { css as classname } from 'emotion'
import { Image, Transformation } from 'cloudinary-react'
import { defer, delay } from 'lodash'
import { showToastByMenuDirection, truncateDefault } from '../../../../../helper/functions'
import { ImageClass, widgetStyles } from './imageHelp'
import { MouseSensor } from 'libreact/lib/MouseSensor'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'
import DialogComp from '../../../../commonInterface/dialog'
import { useTranslation } from 'react-i18next'
import Uppy from '@uppy/core'
import { Dashboard, useUppy } from '@uppy/react'
import koreanLocale from '@uppy/locales/lib/ko_KR'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import XHRUpload from '@uppy/xhr-upload'

// cloudinary.config({
//   cloud_name: 'learnobit',
//   api_key: '997383461231418',
//   api_secret: 'KAMDl1VNWzPPxt_UWp_LqqIHmmw',
//   secure: true
// })

function EditorInNode ({ saveAndUpload }, ref) {
  // const [isUploading, setIsUploading] = useState(false)
  const { t, i18n } = useTranslation()

  const uppyLocale = useMemo(() => {
    switch (i18n.languages[0]) {
      case 'ko':
        return koreanLocale
      default:
        return undefined
    }
  }
  , [i18n.languages])
  const uppy = useUppy(() => {
    // noinspection JSCheckFunctionSignatures
    return new Uppy({
      id: 'uppy1',
      logger: Uppy.debugLogger,
      restrictions: {
        maxFileSize: 10000000,
        maxTotalFileSize: 30000000
      },
      locale: uppyLocale
    })
  })
  useEffect(() => {
    uppy.use(XHRUpload, {
      endpoint: 'https://api.cloudinary.com/v1_1/learnobit/image/upload',
      formData: true,
      metaFields: ['file', 'name', 'upload_preset'],
      fieldName: 'images[]'
    })

    uppy.on('file-added', (file) => {
      uppy.setFileMeta(file.id, {
        file: file.data,
        upload_preset: 'nfcv1f2k'
      })

      if (process.env.NODE_ENV !== 'production') {
        console.tron.display({
          name: 'uppy file-added',
          value: {
            file
          }
          // , important: true
        })
      }
    })

    // uppy.on('upload', (result) => {
    //   if (process.env.NODE_ENV !== 'production') {
    //     console.tron.display({
    //       name: 'uppy upload',
    //       value: {
    //         result
    //       }
    //       // , important: true
    //     })
    //   }
    //
    //   setIsUploading(true)
    // })

    uppy.on('complete', (result) => {
      const files = result.successful

      const imageClasses = files.map((file) => {
        // eslint-disable-next-line camelcase
        const { response: { body: { original_filename, public_id, width, height } } } = file

        return new ImageClass(original_filename, public_id, width, height)
      })

      saveAndUpload(true, imageClasses)

      uppy.reset()

      // if (process.env.NODE_ENV !== 'production') {
      //   console.tron.display({
      //     name: 'uppy complete',
      //     value: {
      //       data: files
      //     }
      //     // , important: true
      //   })
      // }
    })

    return () => {
      uppy.close()
    }
  }, [saveAndUpload, uppy])

  return (
    <div>
      {/* {isUploading ? <LoadingCoverSimple /> : null} */}
      <Dashboard uppy={uppy} proudlyDisplayPoweredByUppy={false} theme={globalOnDemandVars.darkMode() ? 'dark' : 'light'} width={400} height={300} />
    </div>
  )
}

function EditorMini (props, ref) {
  const [imageList, setImageList] = useState([])

  useImperativeHandle(ref, () => ({
    getCurrentMultiContentData: () => {
      return imageList
    },
    clearCurrentEditor: () => { setImageList([]) }
  }), [imageList]
  )

  // const pushToImageList = useCallback(
  //   (newItem) => {
  //     setImageList(produce(imageList, draft => {
  //       draft.push(newItem)
  //     }))
  //   },
  //   [imageList]
  // )
  const deleteFromImageList = useCallback(
    (index) => {
      setImageList(produce(imageList, draft => {
        draft.splice(index, 1)
      }))
    },
    [imageList]
  )

  const uploadWidget = useMemo(() => ({}), [])
  //
  // const uploadWidget = useMemo(() => (
  //   // TODO create 대신 openUploadWidget 으로 할 수도 있음
  //   // eslint-disable-next-line no-undef
  //   cloudinary.createUploadWidget({
  //     cloudName: 'learnobit',
  //     uploadPreset: 'nfcv1f2k',
  //     autoMinimize: true,
  //     maxFiles: 10,
  //     maxFileSize: 10000000,
  //     theme: (globalOnDemandVars.darkMode() ? 'dark' : 'minimal'),
  //     sources: ['local', 'image_search', 'url', 'camera', 'dropbox'],
  //     googleApiKey: 'AIzaSyDWuUL06tMUfeU_yh6oIqnmmKr7vSLIRl0',
  //     dropboxAppKey: 'ztoeix5t31ne06a',
  //     styles: widgetStyles,
  //     language: 'en'
  //   }
  //   , (error, result) => {
  //     if (process.env.NODE_ENV !== 'production') {
  //       console.tron.display({
  //         name: 'cloudinary callback',
  //         value: {
  //           error, result
  //         }
  //         // , important: true
  //       })
  //     }
  //     if (result && result.event === 'queues-end') {
  //       const files = result.info.files
  //       const ImageClasses = files.map((file) => {
  //         if (file.status === 'success') {
  //           return new ImageClass(file.name, file.uploadInfo.public_id, file.uploadInfo.width, file.uploadInfo.height)
  //         } else {
  //           return undefined
  //         }
  //       })
  //       setImageList([].concat(imageList, ImageClasses))
  //
  //       uploadWidget.close({ quiet: true })
  //     }
  //   })
  // ), [imageList])

  const [editOpen, setEditOpen] = useState(false)
  const [editIndex, setEditIndex] = useState(null)
  const [editURL, setEditURL] = useState(null)
  const [cropChange, setCropChange] = useState(null)
  const [currentCrop, setCurrentCrop] = useState(null)

  const { t } = useTranslation()

  return (
    <div css={css`text-align: center; position: absolute; width: 100%; height: 100%; display: flex; flex-direction: column;`}>
      <Button text={'Upload'} icon={'upload'} css={css`margin: 10px auto; width: 80%; flex: none;`} onClick={() => {
        uploadWidget.open()
      }} />
      {!imageList.length ? null : (<hr />)}
      {!imageList.length ? null : (
        <div className={hasScrollbarAlways} css={css`overflow: auto; flex: auto;`}>
          <HTMLTable css={css`width: 100%;`} striped interactive><tbody>{
            imageList.map((ImageClassInstance, index) => (

              <tr css={css`display: flex; width: 100%;`} key={ImageClassInstance.publicId}>
                <td css={css`flex: auto;`}>
                  <Popover
                    content={<div css={css`max-width: 50vw; max-height: 50vh; overflow: auto; position: relative;`}
                      className={hasScrollbarAlways}>
                      <Image cloudName={'learnobit'} publicId={ImageClassInstance.publicId}>
                        {!ImageClassInstance.cropConfig ? null : (
                          <Transformation crop={'crop'} width={ImageClassInstance.cropConfig.width || ImageClassInstance.width} height={ImageClassInstance.cropConfig.height || ImageClassInstance.height} x={ImageClassInstance.cropConfig.x} y={ImageClassInstance.cropConfig.y} />)}
                        <Transformation dpr={'auto'} responsive width={'auto'} responsiveUseBreakpoints={'true'} />
                      </Image>
                    </div>} popoverClassName={classname`background-color: var(--baseColor);`} interactionKind='hover'
                    position='auto' {...OverlayProps}>
                    <div>{truncateDefault(ImageClassInstance.name, true)}</div>
                  </Popover>
                </td>
                <td><Popover
                  content={<div css={css`max-width: 50vw; max-height: 50vh; overflow: auto; position: relative;`}
                    className={hasScrollbarAlways}>
                    <Image cloudName={'learnobit'} publicId={ImageClassInstance.publicId}>
                      {!ImageClassInstance.cropConfig ? null : (
                        <Transformation crop={'crop'} width={ImageClassInstance.cropConfig.width || ImageClassInstance.width} height={ImageClassInstance.cropConfig.height || ImageClassInstance.height} x={ImageClassInstance.cropConfig.x} y={ImageClassInstance.cropConfig.y} />)}
                      <Transformation dpr={'auto'} responsive width={'auto'} responsiveUseBreakpoints={'true'} />
                    </Image>
                  </div>} popoverClassName={classname`background-color: var(--baseColor);`} interactionKind='hover'
                  position='auto' {...OverlayProps}>
                  <Button icon={'edit'} title={t('edit')} minimal onClick={() => {
                    setEditIndex(index)
                    setEditURL(`https://res.cloudinary.com/learnobit/image/upload/v1592995267/${ImageClassInstance.publicId}`)
                    setEditOpen(true)
                    if (ImageClassInstance.cropConfig) {
                      setCropChange({
                        unit: '%',
                        width: ImageClassInstance.cropConfig.width * 100,
                        height: ImageClassInstance.cropConfig.height * 100,
                        x: ImageClassInstance.cropConfig.x * 100,
                        y: ImageClassInstance.cropConfig.y * 100
                      })
                    }
                    // const transformWidget = cloudinary.createUploadWidget({
                    //   cloudName: 'learnobit',
                    //   uploadPreset: 'nfcv1f2k',
                    //   publicId: ImageClassInstance.publicId,
                    //   autoMinimize: true,
                    //   cropping: true,
                    //   showSkipCropButton: false,
                    //   theme: 'minimal',
                    //   styles: widgetStyles
                    // }, (error, result) => {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     console.tron.display({
                    //       name: 'cloudinary callback / transform',
                    //       value: {
                    //         error, result
                    //       }
                    //     // , important: true
                    //     })
                    //   }
                    //   if (result && result.event === 'queues-end') {
                    //     const files = result.info.files
                    //     if (files.length > 1) {
                    //       throw (new Error('multiple files'))
                    //     }
                    //
                    //     const transformedImageClasses = files.map((file) => {
                    //       if (file.status === 'success') {
                    //         return new ImageClass(ImageClassInstance.name, file.uploadInfo.public_id, file.customCoordinates.width, file.customCoordinates.height, file.customCoordinates)
                    //       } else {
                    //         return undefined
                    //       }
                    //     })
                    //     if (transformedImageClasses[0]) {
                    //       const produce1 = produce(imageList, draft => {
                    //         draft[index] = transformedImageClasses[0]
                    //       })
                    //       const produce2 = imageList.slice()
                    //       produce2.splice(index, 1, transformedImageClasses[0])
                    //
                    //       if (process.env.NODE_ENV !== 'production') {
                    //         console.tron.display({
                    //           name: 'cloudinary callback / transform / onClick',
                    //           value: {
                    //             error,
                    //             result,
                    //             nextItem: transformedImageClasses[0],
                    //             prevITem: imageList[index],
                    //             newItems: produce1,
                    //             newItems2: produce2,
                    //             prevItems: imageList
                    //           }
                    //         // , important: true
                    //         })
                    //       }
                    //
                    //       defer(() => {
                    //         setImageList(produce2)
                    //       })
                    //
                    //       if (process.env.NODE_ENV !== 'production') {
                    //         defer(() => {
                    //           console.tron.display({
                    //             name: 'cloudinary callback / transform / onClick 2',
                    //             value: {
                    //               imageList
                    //             }
                    //           // , important: true
                    //           })
                    //         })
                    //       }
                    //     }
                    //   }
                    // })
                    //
                    // transformWidget.open(null, { files: [`https://res.cloudinary.com/learnobit/image/upload/${ImageClassInstance.publicId}`] })
                  }} />
                </Popover></td>
                <td><Button icon={'trash'} title={t('delete')} minimal onClick={() => { deleteFromImageList(index) }} />
                </td>
              </tr>

            ))
          }</tbody></HTMLTable>

          <DialogComp isOpen={editOpen} setDialogOpen={setEditOpen} title={t('Edit Image')} type={'bigger'}>
            <div css={css`max-width: 98%; max-height: 90%; overflow: auto; margin: auto;`}>
              <ReactCrop crop={cropChange} onChange={(crop, percentCrop) => { setCropChange(percentCrop) }} onComplete={(crop, percentCrop) => { setCurrentCrop(percentCrop) }} src={editURL} />
            </div>
            <Button css={css`float: right; position: relative; right: 5px; top: 10px;`} text={'Save & Close'} intent={'primary'} onClick={() => {
              if (currentCrop) {
                const prevImageClassInstance = imageList[editIndex]
                const newImageClassInstance = new ImageClass(prevImageClassInstance.name, prevImageClassInstance.publicId, prevImageClassInstance.width, prevImageClassInstance.height, {
                  width: currentCrop.width / 100,
                  height: currentCrop.height / 100,
                  x: currentCrop.x / 100,
                  y: currentCrop.y / 100
                })
                const newImageList = imageList.slice()
                newImageList.splice(editIndex, 1, newImageClassInstance)
                defer(() => {
                  setImageList(newImageList)
                  showToastByMenuDirection({
                    message: t('imageSaved', { imageName: truncateDefault(newImageClassInstance.name) }),
                    intent: 'primary',
                    icon: 'saved'
                  })
                })
              }

              setEditOpen(false)
            }} />
          </DialogComp>
        </div>)}
    </div>
  )
}
// eslint-disable-next-line no-func-assign
EditorMini = forwardRef(EditorMini)

const imagePopoverWidth = 300
const imagePopoverHeight = 300
export const Render = ({ contentData, replacedForThumbnail }) => {
  const ImageClassInstance = contentData

  const imageElement = useMemo(() => (<Image cloudName={'learnobit'} publicId={ImageClassInstance.publicId}>
    {!ImageClassInstance.cropConfig ? (<Transformation />) : (
      <Transformation crop={'crop'}
        width={ImageClassInstance.cropConfig.width || ImageClassInstance.width} height={ImageClassInstance.cropConfig.height || ImageClassInstance.height} x={ImageClassInstance.cropConfig.x} y={ImageClassInstance.cropConfig.y} />)}
  </Image>), [ImageClassInstance.cropConfig, ImageClassInstance.height, ImageClassInstance.publicId, ImageClassInstance.width])

  const totalView = useMemo(() => (
    !ImageClassInstance || replacedForThumbnail ? null : <div
      // css={css`width: ${Math.floor(ImageClassInstance.width)}px; height: ${Math.floor(ImageClassInstance.height)}px`}>
      css={css`width: 100%; height: 100%;`}>
      {imageElement}
    </div>

  ), [ImageClassInstance, imageElement, replacedForThumbnail])

  const [imageSize, setImageSize] = useState({ width: 0, height: 0 })

  const thumbnailLikeView = useMemo(() => {
    const croppedImageWidth = ImageClassInstance.width * (ImageClassInstance.cropConfig ? ImageClassInstance.cropConfig.width : 1)
    const croppedImageHeight = ImageClassInstance.height * (ImageClassInstance.cropConfig ? ImageClassInstance.cropConfig.height : 1)
    return (
      (
        !replacedForThumbnail ? null : (<MouseSensor bond>
          {state => (
            <Popover {...OverlayProps} interactionKind={'hover'} content={
              <div
                css={css`position: relative; overflow: hidden; width: 100%; height: 100%; min-width: ${imagePopoverWidth}px; min-height: ${imagePopoverHeight}px;`}>
                {/* <div style={{ top: ((-1 * state.elY) * Math.floor(ImageClassInstance.height) / imageSize.height) + 'px', left: ((-1 * state.elX) * Math.floor(ImageClassInstance.width) / imageSize.width) + 'px' }} css={css` */}
                <Icon css={css`z-index: 10; position: absolute; top: calc(50% - 8px); left: calc(50% - 8px);`} icon={'plus'} />
                <div style={{ top: (((-1 * state.elY) * Math.floor(croppedImageHeight) / imageSize.height) + (imagePopoverHeight / 2) + 'px'), left: (((-1 * state.elX) * Math.floor(croppedImageWidth) / imageSize.width) + (imagePopoverWidth / 2) + 'px') }} css={css`
            width: ${Math.floor(croppedImageWidth)}px; height: ${Math.floor(croppedImageHeight)}px;
            position: absolute;
            `}>
                  {imageElement}
                </div>
              </div>
            }>
              <div>
                <ResizeSensor onResize={(entries) => {
                  const width = entries[0].contentRect.width
                  const height = entries[0].contentRect.height
                  setImageSize({ width, height })
                }}>
                  <div {...state.bond}>{imageElement}</div>
                </ResizeSensor>
              </div>
            </Popover>
          )}
        </MouseSensor>)
      )

    )
  }, [ImageClassInstance.cropConfig, ImageClassInstance.height, ImageClassInstance.width, imageElement, imageSize.height, imageSize.width, replacedForThumbnail])
  return replacedForThumbnail ? thumbnailLikeView : totalView
}

const standardHeight = 60
function ThumbNailBase ({ contentData }) {
  const ImageClassInstance = contentData

  // const [containerWidth, setContainerWidth] = useState(0)

  // 이 thumbnail의 container는 position: relative 같은 거여서 position: absolute의 기준이 될 수 있어야 함
  // const resizeSensor = useMemo(() => (<ResizeSensor onResize={(entries) => {
  //   const width = entries[0].contentRect.width
  //   // const height = e.contentRect.height
  //   setContainerWidth(width)
  //   // setContainerHeight(height)
  // }}>
  //   <div css={css`position: absolute; width: 80%; height: 0; appearance: none;`} />
  // </ResizeSensor>), [])

  const image = useMemo(() => (<Card css={css`padding: 0; margin: 1px !important; height: ${standardHeight}px;`}>
    <Image cloudName={'learnobit'} publicId={ImageClassInstance.publicId}>
      {!ImageClassInstance.cropConfig ? null : (
        <Transformation crop={'crop'} width={ImageClassInstance.cropConfig.width || ImageClassInstance.width} height={ImageClassInstance.cropConfig.height || ImageClassInstance.height} x={ImageClassInstance.cropConfig.x} y={ImageClassInstance.cropConfig.y} />)}
      <Transformation width={Math.min(standardHeight, Math.floor(ImageClassInstance.width))} height={Math.min(standardHeight, Math.floor(ImageClassInstance.height))} gravity={'auto'} crop={'thumb'} />
    </Image>
  </Card>), [ImageClassInstance.cropConfig, ImageClassInstance.height, ImageClassInstance.publicId, ImageClassInstance.width])

  return (
    <React.Fragment>

      {/* {resizeSensor} */}

      {image}

    </React.Fragment>
  )
}

const ForImage = new InsertFormClass({
  typeName: 'Image',
  EditorMini,
  EditorInNode,
  Render,
  ThumbNailBase,
  config: { multi: true }
})

export default ForImage
